import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class PublicInformationForm extends AppForm {
  constructor() {
    super({
      description: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
      publicInformationDisclosureJustification: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
    });
  }
}
